<div style="text-align: center;font-size: 14px;">
    <table class="table table-bordered table-sm">
        <thead>
            <tr>
                <th style="background-color: #004c4a; width: 10%; color: #FFF; padding: 4px 8px;">
                    Category
                </th>
                <th style="background-color: #004c4a; width: 10%; color: #FFF; padding: 4px 8px;">
                    Service Code
                </th>
                <th style="background-color: #004c4a; width: 10%; color: #FFF; padding: 4px 8px;">
                    Description
                </th>
                <th style="background-color: #004c4a; width: 10%; color: #FFF; padding: 4px 8px;">
                    Budgeted
                </th>
                <th style="background-color: #004c4a; width: 10%; color: #FFF; padding: 4px 8px;">
                    Spent
                </th>
                <th style="background-color: #004c4a; width: 10%; color: #FFF; padding: 4px 8px;">
                    Remaining
                </th>
            </tr>
        </thead>
        <tbody>
            <ng-container
                *ngFor="let category of chartSummary.categoryGroupsSummary">
                <ng-container
                    *ngFor="let serviceCode of category.servicesSummary; let subIndex = index">
                    <ng-container
                        *ngFor="let item of serviceCode.data; let itemIndex = index">
                        <tr>
                            <td *ngIf="itemIndex === 0 && subIndex === 0" style="vertical-align: middle;"
                                [attr.rowspan]="category.totalItems">{{category.category}}</td>
                            <td *ngIf="itemIndex === 0" style="vertical-align: middle;"
                                [attr.rowspan]="serviceCode.totalItems">{{serviceCode.serviceCode}}</td>
                            <td>{{item.description}}</td>
                            <td>{{item.totalAuth | currency}}</td>
                            <td>{{item.spent | currency}}</td>
                            <td>{{item.remaining | currency}}</td>
                        </tr>
                    </ng-container>
                </ng-container>
                <tr *ngIf="category.totalItems > 0">
                    <td>Category Total</td>
                    <td></td>
                    <td></td>
                    <td>{{category.totalBudgeted | currency}}</td>
                    <td>{{category.totalSpent | currency}}</td>
                    <td>{{category.totalRemaining | currency}}</td>
                </tr>
            </ng-container>
            <tr>
                <td style="background-color: #004c4a;color: #FFF; font-weight: bold;">Total Budget</td>
                <td style="background-color: #004c4a;color: #FFF; font-weight: bold;"></td>
                <td style="background-color: #004c4a;color: #FFF; font-weight: bold;"></td>
                <td style="background-color: #004c4a;color: #FFF; font-weight: bold;">{{chartSummary.totalBudgeted | currency}}</td>
                <td style="background-color: #004c4a;color: #FFF; font-weight: bold;">{{chartSummary.totalSpent | currency}}</td>
                <td style="background-color: #004c4a;color: #FFF; font-weight: bold;">{{chartSummary.totalRemaining | currency}}</td>
            </tr>
        </tbody>
    </table>
</div>